import {
  Box,
  Breadcrumbs,
  Link as MLink,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import {
  AccessibleTwoTone,
  ChevronRightTwoTone,
  HealingTwoTone,
  HomeTwoTone,
  VaccinesTwoTone,
} from '@mui/icons-material';

export function GuidanceTourHealthPage() {
  const { t } = useTranslation();
  const { salesIndividualId } = useParams();
  const [searchParams] = useSearchParams();
  const tourId = searchParams.get('tourId');

  if (!salesIndividualId) return null;

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t('guidanceTourHealth.title')}
      </Typography>

      <Breadcrumbs sx={{ mb: 1 }}>
        <MLink
          component={Link}
          to="/"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeTwoTone />
        </MLink>
        <MLink component={Link} to="/account">
          {t('nav.account')}
        </MLink>
        <MLink to="/account/guidance" component={Link}>
          <Typography>{t('nav.guidance')}</Typography>
        </MLink>
        <MLink
          component={Link}
          to={`/account/guidance/${salesIndividualId}?tourId=${tourId}`}
        >
          {t('nav.tourId', { tourId })}
        </MLink>
        <Typography>{t('nav.health')}</Typography>
      </Breadcrumbs>
      <Typography variant="h6" sx={{ mt: 4 }}>
        {t('guidanceTourHealth.title')}
      </Typography>
      <Paper sx={{ maxWidth: 'sm', mt: 2 }}>
        <List>
          <ListItemButton
            component={Link}
            to={`/account/guidance/${salesIndividualId}/health/disability?tourId=${tourId}`}
          >
            <ListItemIcon>
              <AccessibleTwoTone />
            </ListItemIcon>
            <ListItemText primary={t('guidanceTourHealth.disability')} />
            <Stack direction="row" spacing={1}>
              <ChevronRightTwoTone />
            </Stack>
          </ListItemButton>
          <ListItemButton
            component={Link}
            to={`/account/guidance/${salesIndividualId}/health/dialysis?tourId=${tourId}`}
          >
            <ListItemIcon>
              <VaccinesTwoTone />
            </ListItemIcon>
            <ListItemText primary={t('guidanceTourHealth.dialysis')} />
            <Stack direction="row" spacing={1}>
              <ChevronRightTwoTone />
            </Stack>
          </ListItemButton>
          <ListItemButton
            component={Link}
            to={`/account/guidance/${salesIndividualId}/health/medicine?tourId=${tourId}`}
          >
            <ListItemIcon>
              <HealingTwoTone />
            </ListItemIcon>
            <ListItemText primary={t('guidanceTourHealth.medicine')} />
            <Stack direction="row" spacing={1}>
              <ChevronRightTwoTone />
            </Stack>
          </ListItemButton>
        </List>
      </Paper>
    </Box>
  );
}
